import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SliderModel } from '../../models/slider.model';
import { AlertService } from '../../services/alert.service';
import { LoginService } from '../../services/login.service';
// import { SliderService } from '../../services/slider.service';

@Component({
  selector: 'app-slider-card',
  templateUrl: './slider-card.component.html',
  styleUrls: ['./slider-card.component.scss'],
})
export class SliderCardComponent implements OnInit {
  isLogged;
  @Input() slider: SliderModel;

  constructor(
    public alerta: AlertService,
    private router: Router,
    private authService: LoginService
  ) {}

  ngOnInit() {
    this.isLogged = this.authService.estaAutenticado();
  }

  deleteSlider(slidertId) {
    this.alerta.deleteSlider(slidertId).then(() => {});
  }

  updateSlider(slidertId) {
    this.router.navigate(['slider-update', slidertId]);
  }
}
